import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Route, Switch } from 'react-router-dom';
import TestErrors from '../../features/errors/TestError';
import { ToastContainer } from 'react-toastify';
import NotFound from '../../features/errors/NotFound';
import ServerError from '../../features/errors/ServerError';
import LoginForm from '../../features/users/LoginForm';
import { useStore } from '../stores/store';
import LoadingComponent from './LoadingComponent';
import ModalContainer from '../common/modals/ModalContainer';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import TedarikciTanimlama from '../../features/dashboard/Dashboard';
import ImageView from '../../features/nkaImages/ImageView';


function App() {
  const { commonStore, userStore } = useStore();

  useEffect(() => {
    if (commonStore.token) {
      userStore.getUser().finally(() => commonStore.setAppLoaded());
    } else {
      commonStore.setAppLoaded();
    }
  }, [commonStore, userStore])

  if (!commonStore.appLoaded) return <LoadingComponent content='Uygulama yükleniyor...' />

  return (
    <div style={{ height: '100%' }}>
      <ToastContainer position='top-center' hideProgressBar />
      <ModalContainer />
      <PublicRoute exact path='/' component={LoginForm} />
      <Route
        path={'/(.+)'}
        render={() => (
          <>
            <Switch>
              <PrivateRoute exact path='/dashboard' component={TedarikciTanimlama} />
              <PrivateRoute path='/errors' component={TestErrors} />
              <Route path='/server-error' component={ServerError} />
              <Route path='/image' component={ImageView} />
              <PublicRoute path='/login' component={LoginForm} />
              <Route component={NotFound} />
            </Switch>
          </>
        )}
      />
    </div>
  );
}

export default observer(App);
